export const MAILERLITE_CONFIG = {
  // Form configuration (frontend only)
  FORM_TITLE: 'Join the Flux Directorate',
  FORM_DESCRIPTION: 'Get the Dimension Flux newsletter with news from the Directorate',

  // Error messages
  ERROR_MESSAGES: {
    ALREADY_SUBSCRIBED: 'This email is already subscribed to our newsletter.',
    INVALID_EMAIL: 'Please enter a valid email address.',
    NETWORK_ERROR: 'There was an error subscribing. Please try again.',
    SUCCESS: 'Successfully subscribed! Please check your email to confirm.',
  }
};
